export const parseText = (text: any, i18n: any) => {
    const getFirstTwoChars = (text: string): string => {
        return text.length > 2 ? text.slice(0, 2) : text;
    };

    // Se text è già un oggetto, usa direttamente le prime due lettere della lingua
    if (typeof text === 'object' && text !== null) {
        const langKey = getFirstTwoChars(i18n.language);
        return text[langKey] || text[i18n.language] || '';
    }

    try {
        // Controlla se è un JSON stringificato
        const parsed = JSON.parse(text);
        // Se il parsing riesce ed è un oggetto, ritorna il risultato
        if (typeof parsed === 'object' && parsed !== null) {
            const langKey = getFirstTwoChars(i18n.language);
            return parsed[langKey] || parsed[i18n.language] || '';
        }
    } catch (error) {
        // Non fare nulla, non è un JSON valido
    }

    // Ritorna il valore originale se è una stringa semplice
    return text;
};